import React, { memo } from 'react';
import UseDfpSlot from './UseDfpSlot';

const LateralDerecho = () => {
    
    UseDfpSlot({
        path: '/28253241/elcomercio/web/post/especiales/lateralr',
        size: [[160, 600], 'fluid', [120, 600]],
        id: 'div-gpt-ad-1595370138328-0',
    });

    return (
        <aside className="d-none d-xl-block position-fixed end-0 me-4 text-start lateral-der">
            <div id="div-gpt-ad-1595370138328-0"></div> 
        </aside>
    )
}

export default memo(LateralDerecho);
